import React from 'react';
import PropTypes from "prop-types";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import { daysOfOperation } from '../../../constants/constants';
import moment from 'moment';
import {
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    Box,
  } from "@mui/material";



const theme = createTheme({
    typography: {
      h6: {
        fontFamily: "Texta-bold",
      },
      subtitle1: {
        fontFamily: ["Texta-book", "Helvetica", "Arial", "sans-serif"].join(','),
        fontSize: 20,
      },
    },
  });
const PaymentDetails = ({row}) => {

    const filterDay = (dayValue) =>{
        let tempData = daysOfOperation.filter((data)=> data.weekDay == dayValue)
          return tempData[0]?.values;
      }
    const formatPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) {
          return '-';
        }
      
        const cleaned = ('' + phoneNumber).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
      
        return phoneNumber;
      };

      const formatStatus = (item) => {
        if (item == "CANCLD") {
          return <div color="#3f6f8f" fontWeight="bold"> Cancelled </div>
        } else if (item == "SUCESS") {
          return <div color="#3f6f8f" fontWeight="bold"> Successful </div>
        } else if (item == "REJCTD") {
          return <div color="#3f6f8f" fontWeight="bold"> Rejected </div>
        } else if (item == "SCHDLD") {
          return <span color="#3f6f8f" fontWeight="bold">Scheduled</span>
        }
      }

  return (
    <Grid container className="collapsibleTable" spacing={2} paddingBottom={2}>
        <ThemeProvider theme={theme}>
            <Grid item xs={4}>
                 <Typography variant="h6" gutterBottom component="div">
                    Client Full Name
                 </Typography>
                <Typography variant="label" gutterBottom>
                    {row.clientNam ? row.clientNam : '-'}
                </Typography>            
            </Grid>
            <Grid item xs={4} className="word-wrap">
                <Typography variant="h6" gutterBottom component="div">
                    Email
                 </Typography>
                <Typography variant="label" gutterBottom>
                    {row.clientEmail ? row.clientEmail : '-'}
                </Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant="h6" gutterBottom component="div">
                   Phone
                 </Typography>
                <Typography variant="label" gutterBottom>
                    {row.phoneNumber ? formatPhoneNumber(row.phoneNumber) : '-'} 
                </Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant="h6" gutterBottom component="div">
                    Client Preferred Phone
                </Typography>
                <Typography variant="label" gutterBottom>
                    {row.clientPreferdPhone ? formatPhoneNumber(row.clientPreferdPhone) : '-'} 
                </Typography>
            </Grid>
            <Grid item xs={4} className="word-wrap">
                <Typography variant="h6" gutterBottom component="div">
                    Client Preferred Email
                </Typography>
                <Typography variant="label" gutterBottom>
                    {row.clientPreferdEmail ? row.clientPreferdEmail : '-'} 
                </Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography variant="h6" gutterBottom component="div">
                    Last Updated Time
                </Typography>
                <Typography variant="label" gutterBottom>
                 { row.lastUpdtTs? moment(row.lastUpdtTs).format('MM/DD/YYYY h:mm A') : '-'}
                </Typography>
            </Grid>
            <Grid item xs={6}>
                  <Typography variant="h6" gutterBottom component="div">
                      Pickup/Delivery Location
                  </Typography>
                  <Typography variant="label" gutterBottom className="word-wrap"> 
                      {[
                          row.address1,
                          row.address2,
                          row.city,
                          row.state,
                          row.zipcode
                      ]
                          .filter(value => value !== undefined && value !== "")
                          .join(", ") || "-"}
                      <Typography variant="label" gutterBottom component="div">

                          {row?.day && row?.openTime && row?.closeTime ? (
                              <div>
                                  <AccessTimeRoundedIcon />
                                  {` ${filterDay(row?.day)}, ${row?.openTime}-${row?.closeTime}`}
                              </div>
                          ) : null}
                      </Typography>
                  </Typography>
              </Grid>
              <Grid item xs={10}>
                    <Typography variant="h5" display="inline" className="resText text-capitalize" gutterBottom component="div">
                        Payment Details
                    </Typography>
               </Grid>
              <Grid item xs={10}>
                  <Box padding={'16px'}>
                      <Box width={"565px"}>
                          <Table sx={{
                              '& > thead > tr > th, & > tbody > tr > td':
                                  { border: '1px solid #dee2e6' }
                          }} aria-label="collapsible table">
                              <TableHead border={"2px"}>
                                  <TableRow >
                                      <TableCell>Payment Date</TableCell>
                                      <TableCell>Payment Amount</TableCell>
                                      <TableCell>Payment Status</TableCell>
                                  </TableRow>
                              </TableHead>
                              <TableBody>
                                  {Array.isArray(row?.paymentScheduleList) ? (
                                      row?.paymentScheduleList?.map((item) => (
                                          <TableRow key={item.id} sx={{ backgroundColor: "#fff" }}>
                                              <TableCell>{moment(item.paymentSchdulDate).format('MM/DD/YYYY')}</TableCell>
                                              <TableCell>${item.paymentAmount}</TableCell>
                                              <TableCell>{formatStatus(item.paymentStatus)}</TableCell>
                                          </TableRow>
                                      ))
                                  ) : (
                                      <TableRow>
                                          <TableCell colSpan={3}>No payment schedule data available.</TableCell>
                                      </TableRow>
                                  )}
                              </TableBody>
                          </Table>
                      </Box>
                  </Box>
              </Grid>         
        </ThemeProvider>
    </Grid>
  )
}

PaymentDetails.propTypes = {
    row: PropTypes.object.isRequired,
};

export default PaymentDetails